export const OVERLAY_INITIAL = "overlay__initial";
export const OVERLAY_UUID = "overlay__uuid";
export const OVERLAY_CONTAINER = "overlay__container";
export const OFF_OVERLAY_CLASS = "overlay__offContent";

export const DEFAULT_OVERLAY_STYLES = {
  backgroundColor: "rgba(67, 90, 111, 0.7)"
};
